import { jsx as _jsx } from "react/jsx-runtime";
import YesNoSingleSelect from '../select/YesNoSingleSelect';
export const FilterYesNoSelect = ({ item, setFilter, activeFilters, label, isAlwaysVisible, placeholder, enabled, }) => ({
    filterItem: item,
    enabled: enabled,
    filterSelectLabel: !isAlwaysVisible ? label : undefined,
    element: (_jsx(YesNoSingleSelect, { value: activeFilters[item], onChange: value => setFilter({ [item]: value }), placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : label })),
});
